import * as React from "react";
import { MessageContentProps } from "./types";
import { Content, ContentLoading } from "./styles";
import MarkdownIt from "markdown-it";

const md = new MarkdownIt({
    linkify: true,
    breaks: true,
});

md.disable("list");

md.linkify.set({
    fuzzyEmail: false,
    fuzzyIP: false,
    fuzzyLink: false,
});

const PlainTextMessageContent = ({ message }: MessageContentProps) => {
    const Component = message.isLocal ? ContentLoading : Content;

    return <Component dangerouslySetInnerHTML={{ __html: md.render(message.content) }} />;
};

export default PlainTextMessageContent;
